import request from '@/utils/request'
// 媒体列表
export function medialist(params = {}) {
  return request({
    url: '/adx_media/list',
    method: 'get',
    params
  })
}
// 新增任务
export function createAdxTask(data = {}) {
  return request({
    url: '/adx_task/create',
    method: 'post',
    data
  })
}
// 任务列表
export function taskList(params = {}) {
  return request({
    url: '/adx_task/list',
    method: 'get',
    params
  })
}
// 停止任务，重启任务
export function stopTask(data = {}) {
  return request({
    url: '/adx_task/stopTask',
    method: 'post',
    data
  })
}
// 任务详情
export function taskDetail(params = {}) {
  return request({
    url: '/adx_task/detail',
    method: 'get',
    params
  })
}
// 编辑任务
export function updateTask(data = {}) {
  return request({
    url: '/adx_task/update',
    method: 'post',
    data
  })
}
